import React, { useState, useEffect, useRef } from "react";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import { Button, TextField, Grid, Tooltip, IconButton } from "@mui/material";
import axios from "../../../../axios-order";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { canWrite } from '../../../../utils/privilegeUtils';

export default function IMSRepositoryOutward() {

    const [fileDataToUpload, setFileDataToUpload] = useState("");
    const [fileName, setFileName] = useState("");
    const history = useHistory();
    const [colorForErrorMessage, setColorForErrorMessage] = useState("red");
    const [errorMessage, setErrorMessage] = useState("");
    const [loaderForTable, setLoaderForTable] = useState(false);
    const [recordForTable, setRecordForTable] = useState([]);
    const [recordForTableSearch, setRecordForTableSearch] = useState([]);
    const [businessEntityId, setBusinessEntityId] = useState(localStorage.getItem("business_entity_id"));
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [selectedRemark, setSelectedRemark] = useState('');
    const [responseMessage, setResponseMessage] = useState("");

    const [errorMessageVisibilityStyle, setErrorMessageVisibilityStyle] =
        useState("hidden");
    const [errorMessageDisplayStyle, setErrorMessageDisplayStyle] =
        useState("none");

    const handleFileUpload = (e) => {
        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
        if (e.target.files.length) {
            const file_data = e.target.files[0];
            let fileName = file_data.name;
            setFileName(fileName);
            const reader = new FileReader();
            reader.readAsDataURL(file_data);
            reader.onload = function () {
                let file_value = reader.result;
                setFileDataToUpload(file_value);
            };
            e.target.value = null;
        }
    };

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setResponseMessage(message);
    };

    const handleBackNavigation = () => {
        history.push("/repoCards");
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setResponseMessage("");
    };

    const getApiImsRepositoryOutward = () => {
        setLoaderForTable(true);
        axios
            .get(`/ims_outward_repo_summary/${businessEntityId}`)
            .then((res) => {
                if (res.data.status === true) {
                    setLoaderForTable(false);
                    setRecordForTable(res.data.data);
                    setRecordForTableSearch(res.data.data);
                } else {
                    setLoaderForTable(false);
                    alert(res.data.message);
                }
            })
            .catch(() => setLoaderForTable(false));
    };

    useEffect(() => {
        getApiImsRepositoryOutward();
    }, []);

    const handleSearch = (e) => {
        let Search = e.target.value.trim();
        const searchName = recordForTableSearch.filter((v) => {
            return (
                String(v.gstr_upload_file_type)
                    .toLowerCase()
                    .indexOf(Search.toLowerCase()) >= 0 ||
                String(v.financial_year).toLowerCase().indexOf(Search.toLowerCase()) >=
                0 ||
                String(v.generation_date).toLowerCase().indexOf(Search.toLowerCase()) >=
                0 ||
                String(moment(v.tax_period, "MMYYYY").format("MM-YYYY")).indexOf(
                    Search
                ) >= 0 ||
                String(
                    moment(v.upload_date, "YYYY-MM-DD").format("DD-MM-YYYY")
                ).indexOf(Search) >= 0
            );
        });
        setRecordForTable(searchName);
    };

    const handleRemarkClick = (remark, status) => {
        setSelectedRemark(remark || 'No remark available');
        setSnackbarSeverity(status === "Fail" || status === "FAILED" ? "error" : "success");
        setSnackbarOpen(true);
    };

    const fileInputRef = useRef(null);
    const functionForSuccesfullMessageAndErroeMessage = (
        color,
        visible,
        display,
        message
    ) => {
        setColorForErrorMessage(color);
        setErrorMessageVisibilityStyle(visible);
        setErrorMessageDisplayStyle(display);
        setErrorMessage(message);
    };


    const fileUploadCancelButton = () => {
        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
        setFileDataToUpload("");
        setFileName("");
    };


    const resetFileUpload = () => {
        setFileDataToUpload(null);
        setFileName('');
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleSubmit = (e) => {
        functionForSuccesfullMessageAndErroeMessage(
            "green",
            "visible",
            "block",
            "Uploading file Please Wait..."
        );
        if (fileName === "") {
            functionForSuccesfullMessageAndErroeMessage(
                "red",
                "visible",
                "block",
                "Please Upload The File!"
            );
        } else {
            axios
                .post(`/ims_outward_upload_asy`, {
                    file: fileDataToUpload,
                    document_name: fileName,
                    business_entity_id: localStorage.getItem('business_entity_id')
                })
                .then((res) => {
                    if (res.data.status === true) {
                        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
                        getApiImsRepositoryOutward();
                        resetFileUpload();
                    } else {
                        functionForSuccesfullMessageAndErroeMessage(
                            "red",
                            "visible",
                            "block",
                            res.data.Message
                        );
                        resetFileUpload();
                    }
                })
                .catch((error) => {
                    functionForSuccesfullMessageAndErroeMessage(
                        "red",
                        "visible",
                        "block",
                        error.response.data.Message
                    );
                    resetFileUpload();
                });
        }
    };

    return (
        <React.Fragment>
            <div style={{ padding: "15px 20px", backgroundColor: "#f5f5f5" }}>
                <Tooltip title="Back" arrow>
                    <IconButton
                        onClick={handleBackNavigation}
                        sx={{
                            borderRadius: '50%',
                            padding: '6px',
                            color: '#263238',
                            fontSize: '20px',
                            backgroundColor: '#ffffff',
                            height: '36px',
                            width: '36px',
                            '&:hover': {
                                backgroundColor: '#455a64',
                                color: '#ffffff',
                            },
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                            transition: 'background-color 0.3s ease',
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: '20px' }} />
                    </IconButton>
                </Tooltip>
            </div>

            {/* Upload Section – Always Visible */}
            {canWrite("IMS-OUTWARD") && (
            <BoxWrapper boxTitle="Upload IMS Repository">
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <label className="button-primary" style={{ cursor: "pointer" }}>
                        Upload
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".xlsx, .zip"
                            onChange={handleFileUpload}
                            hidden
                        />
                    </label>

                    <div>
                        <TextField
                            value={fileName}
                            variant="standard"
                            style={{ width: "350px", paddingLeft: "10px" }}
                            placeholder="No Data Have Uploaded"
                            inputProps={{ readOnly: true }}
                        />
                    </div>

                    <div>
                        <button
                            className="button-primary"
                            style={{ marginLeft: "10px" }}
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>

                        <button
                            className="button-outlined-secondary"
                            onClick={fileUploadCancelButton}
                        >
                            Cancel
                        </button>
                    </div>
                </div>

                <div
                    style={{
                        color: colorForErrorMessage,
                        padding: "5px",
                        fontWeight: "600",
                        visibility: errorMessageVisibilityStyle,
                        display: errorMessageDisplayStyle,
                    }}
                >
                    {errorMessage}
                </div>
            </BoxWrapper>
            )}

            {/* Repository Table */}
            <BoxWrapper
                boxTitle="IMS Outward Repository"
                enableSearchInput={true}
                searchInputPlaceholder="Search..."
                searchInputOnchange={handleSearch}
                enableAddButton={true}
                addButtonLabel="Refresh"
                addButtonHandlerFn={getApiImsRepositoryOutward}
            >
                <div className="responsive-table">
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>Financial year</th>
                                <th>Return period</th>
                                <th>IMS outward file type</th>
                                <th>Uploaded date time</th>
                                <th>Modified date time</th>
                                <th>Status</th>
                                <th>Remark</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recordForTable?.map((v, index) => (
                                <tr key={index}>
                                    <td>{v.financial_year}</td>
                                    <td>{v.return_period}</td>
                                    <td>{v.ims_outward_file_type}</td>
                                    <td>{v.uploaded_datetime}</td>
                                    <td>{v.modified_datetime}</td>
                                    <td>{v.status}</td>
                                    <td>
                                        <VisibilityOutlinedIcon
                                            className="action-icon-button showIcon"
                                            onClick={() =>
                                                handleRemarkClick(v.remarks, v.status)
                                            }
                                        />
                                    </td>
                                </tr>
                            ))}

                            {loaderForTable ? (
                                <tr>
                                    <td colSpan={7} style={{ textAlign: "center" }}>
                                        Loading…Please wait
                                    </td>
                                </tr>
                            ) : recordForTable?.length === 0 ? (
                                <tr>
                                    <td colSpan={7} style={{ color: "red", textAlign: "center" }}>
                                        No Data Found!
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>
            </BoxWrapper>

            {/* Snackbar */}
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                style={{ maxWidth: "25%" }}
            >
                <MuiAlert
                    elevation={2}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {selectedRemark || responseMessage}
                </MuiAlert>
            </Snackbar>

        </React.Fragment>
    );

}

